import AuthContentWrapper from "./components/AuthContentWrapper";
import CustomIcon from "../../common/components/image/CustomIcon";
import { useNavigate } from "react-router-dom";
import { Column, SizedBox } from "../../common/components/CommonBaseComponents";
import { C2Text, T1Text } from "../../common/components/text/CustomText";
import CustomInput from "../../common/components/input/CustomInput";
import { useState } from "react";
import FullWidthButton from "../../common/components/button/FullWidthButton";
import ValidUtil from "../../common/utils/ValidUtil";
import Translate from "../../common/translate/Translate";
import AuthService from "../../service/AuthService";
import CustomPopup from "../../common/components/popup/CustomPopup";
import { Theme } from "../../common/Theme";

function RequestResetPasswordPage() {
    const navigate = useNavigate();
    const service = new AuthService();

    const [isEmailSent, setIsEmailSent] = useState(false);

    const [email, setEmail] = useState("");

    function handleHistoryBack() {
        if (!isEmailSent) {
            navigate(-1);
        } else {
            setIsEmailSent(false);
        }
    }

    // api 에러 팝업
    const [isPopupOpened, setIsPopupOpened] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    async function handleVerifyEmail() {
        if (!isEmailValid) {
            return;
        }
        try {
            await service.sendResetPasswordMail({ userid: email });

            setIsEmailSent(true);
        } catch (error) {
            setPopupMessage(error.message);
            setIsPopupOpened(true);
        }
    }

    const isEmailValid = ValidUtil.isValidEmail(email);

    return (
        <AuthContentWrapper contentPadding={"20px"}>
            <CustomIcon iconName={"undo"} size={"36px"} onClick={handleHistoryBack} cursor={"pointer"} />
            <SizedBox height={"6px"} />
            {!isEmailSent && (
                <>
                    <Column justifyContent={"center"}>
                        <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                            {Translate("auth.resetPassword.title")}
                        </T1Text>
                        <SizedBox height={"10px"} />
                        <C2Text fontColor={Theme.color.gray500}>{Translate("auth.resetPassword.subtitle1")}</C2Text>
                        <C2Text fontColor={Theme.color.gray500}>{Translate("auth.resetPassword.subtitle2")}</C2Text>
                    </Column>
                    <Column padding={"0 40px"} justifyContent={"flex-start"} alignItem={"flex-start"}>
                        <SizedBox height={"27px"} />
                        <C2Text fontWeight={"500"}>{Translate("auth.email")}</C2Text>
                        <SizedBox height={"6px"} />
                        <CustomInput
                            placeholder={Translate("placeholder.email")}
                            type={"email"}
                            padding={"15px 16px"}
                            inputValue={email}
                            setInputValue={setEmail}
                            isValid={isEmailValid || !(email.length > 0)}
                        />
                        <SizedBox height={isEmailValid || !(email.length > 0) ? "32px" : "11px"} />
                        <FullWidthButton
                            onClick={handleVerifyEmail}
                            text={Translate("common.ok")}
                            isActive={isEmailValid}
                        />
                        <SizedBox height={"42px"} />
                    </Column>
                </>
            )}
            {isEmailSent && (
                <>
                    <Column justifyContent={"center"} padding={"0 40px"}>
                        <T1Text letterSpacing={"-0.56px"} fontWeight={"500"}>
                            {Translate("common.laundryCrew")} {Translate("role.admin")}
                        </T1Text>
                        <SizedBox height={"10px"} />
                        <C2Text fontColor={Theme.color.gray500}>{Translate("auth.resetPassword.subtitle3")}</C2Text>
                        <SizedBox height={"44px"} />
                        <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                            {Translate("auth.resetPassword.completeMessage1", [email])}
                        </C2Text>
                        <SizedBox height={"20px"} />
                        <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                            {Translate("auth.resetPassword.completeMessage2")}
                        </C2Text>
                        <SizedBox height={"20px"} />
                        <C2Text fontColor={Theme.color.gray500}>
                            {Translate("auth.resetPassword.completeMessage3")}
                        </C2Text>
                        <SizedBox height={"20px"} />
                        <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                            {Translate("auth.resetPassword.completeMessage4")}
                        </C2Text>
                        <C2Text fontColor={Theme.color.gray500} textAlign={"center"}>
                            {Translate("auth.resetPassword.completeMessage5")}
                        </C2Text>
                        <SizedBox height={"32px"} />
                        <FullWidthButton onClick={() => navigate("/auth/login")} text={Translate("common.ok")} />
                        <SizedBox height={"42px"} />
                    </Column>
                </>
            )}
            <CustomPopup isOpen={isPopupOpened} onConfirm={() => setIsPopupOpened(false)} message={popupMessage} />
        </AuthContentWrapper>
    );
}

export default RequestResetPasswordPage;
